import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
  name: 'generate-vehicle-trip-print',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      tripIdForMail:'',
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      emailIdValidationMSG:'',
      emailIdErrorMSG:'',
      mailId:'',
      showemailpage:false,
      hubid: 0,
      tripDate: '',
      FromDate:'',
      ToDate:'',
      toDate:'',
      VendorNameData: [],
      vendorNameObjData: {
        value: "",
        text: ""
      },
      vendorName: '',
      vendorLoading: '',
      hubdetailsarray: [],
      DestHubNameData: [],
      allVendor: [],
      VehicleTripBagDetails: [],
      printData: [],
      isLoadingSearch: false,
      tripSheetData: {},
      ResponseData: [],
      showModal: false,
      PrintDate: '',
      PrintBy: '',
      pageNo: 0,
      limit: 10,

      showTable: false,
      isLoading: false,
      createdBy: "",
      bagNumber: "", //xb-vadodara8
      bagDetails: {
        bagno: "",
        originhubname: "",
        destinationhubname: "",
        bagtype: "",
        totalshipmentsinbag: "",
        routemode: null
      },

    }
  },
  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).utc().format('DD-MM-YYYY HH:mm:ss');
    },
    TotalVolWt: function(data) {
      return data.reduce(function(totalVolWt, item) {
        return totalVolWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalPhyWt: function(data) {
      return data.reduce(function(totalPhyWt, item) {
        return totalPhyWt + parseFloat(item.physicalweight);
      }, 0);
    },
    TotalShipment: function(data) {
      return data.reduce(function(totalShipment, item) {
        return totalShipment + parseFloat(item.shippingbagcnt);
      }, 0);
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.createdBy = userdetail[0].email;
    this.PrintBy = this.createdBy;
    this.PrintDate = new Date();
    this.hubid = userdetail[0].HubId;
    this.getVendor();
  },
  methods: {
    resetFormForMail(){
      this.mailId='',
      this.emailIdErrorMSG='',
      this.tripIdForMail='',
      this.emailIdValidationMSG=''
    },
    SendMailFunction(){
      this.emailIdValidationMSG=''
      this.emailIdErrorMSG=''
      if(this.mailId =='' || this.mailId == undefined)
      {
        this.emailIdErrorMSG="Enter Email-Id"
        return false
      }
      var mailArray=[];
      mailArray = this.mailId.split(',');
      for(var i=0;i<mailArray.length;i++)
    {
      if(this.regForMail.test(mailArray[i]) == false)
      {
        this.emailIdValidationMSG="Invalid MailId"+" "+mailArray[i]
        return false
      }
    }
      this.input = {
        "TripID":Number(this.tripIdForMail),
        "To":this.mailId
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops  + 'emailLocalConnectionPrealert',
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          if (response.ResultCode == 100) {
            this.$alertify.success(response.ReturnMessage)
            this.resetFormForMail()
            this.closeSendMailPage()
          } else {
            this.$alertify.error(response.ReturnMessage)
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    closeSendMailPage(){
      this.showemailpage = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.resetFormForMail();
    },
    sendMail(data){
      this.tripIdForMail=data.tripid
      this.showemailpage=true;
    },
    selectedVendor(vendorName) {
      this.vendorNameObjData = vendorName;
      this.vendorName = this.vendorNameObjData.text
      var a = this.vendorNameObjData.value
      this.VendorNameData = this.allVendor.filter(function(el) {
        return el.value != a
      });
      this.vendorName = vendorName.value
    },
    getVendor() {
      this.vendorLoading = 'Loading Vendors...'
      var i = 0;
      var self = this
      this.input = {}
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetVendorListTP',
          'data':this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.vendorLoading = ''
          if (result.data.ResultCode == 100){
            var VendorData = result.data.ResponseData
            this.hubdetailsarray = result.data.ResponseData
            for (i = 0; i < VendorData.length; i++) {
              this.VendorNameData.push({
                value: VendorData[i].VehicleVendorCompanyID,
                text: VendorData[i].VehicleVendorCompanyName
              })
              this.VendorNameData = this.VendorNameData
              this.allVendor = this.VendorNameData
            }
          }
        }, error => {
          this.vendorLoading = ''
          console.error(error)
        })
    },
    checkToDate() {
      var date1 = new Date(this.FromDate);
      date1.setDate(date1.getDate() + 30)
      this.validDateRange = date1

      var date2 = new Date(this.ToDate);
      date2.setDate(date2.getDate() + 30)
      this.validDateRange = date2

        },
    getVehicleTripBagDetails() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var fromDate = moment(this.FromDate).format('YYYY-MM-DD HH:mm:ss')
          var toDate= moment(this.ToDate).format('YYYY-MM-DD HH:mm:ss')
          this.isLoading = true
          axios({
              method: 'GET',
              'url': apiUrl.allocateRuleapi_url + 'getVehicleTripBagDetails?hubId=' + this.hubid + '&vendorId=' + this.vendorName + '&fromDate=' + fromDate +
               '&toDate='+toDate +  '&offset=' + this.pageNo + '&limit=' + this.limit,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
              if (result.data.ResultCode == 100) {
                this.isLoading = true;
                this.showTable = true;
                this.VehicleTripBagDetails = result.data.ResponseData;
                if (this.totalRows < 10) {
                  this.pageCount = 1
                } else {
                  this.pageCount = Math.ceil(this.totalRows / 10);
                }
              } else if (result.data.ResultCode == 101) {
                this.VehicleTripBagDetails = [];
                this.isLoading = false;
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              } else {
                this.VehicleTripBagDetails = [];
                this.isLoading = false;
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage.name)
              }
              this.isLoading = false
            }, error => {
              this.isLoadingSearch = false;
              this.isLoading = false
              console.error(error)
            })
        }
      });
    },
    printeVehicleTripBagDetails(data) {
      axios({
          method: "GET",
          'url': apiUrl.allocateRuleapi_url + 'getVehicleTripDetails?tripId=' + data.tripid,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.tripSheetData = result.data
            this.ResponseData = result.data.ResponseData;
            this.showModal = true;
            this.isLoading = false;
            this.showTable = true;
          } else if (result.data.ResultCode == 101) {
            this.showModal = false;
            this.tripSheetData = {};
            this.ResponseData = [];
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.showModal = false;
            this.tripSheetData = {};
            this.ResponseData = [];
            this.$alertify.error(result.data.ReturnMessage.name)
          }
        }, error => {
          this.isLoading = false
          console.log(error);
        })
    },
    printSheet() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('PrintSheet'), cssText);
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getVehicleTripSummary()
    },
    closeModal() {
      this.showModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    resetForm() {
      this.tripIdForMail='';
      this.FromDate = '';
      this.ToDate = '';
      this.bagDetails = {};
      this.vendorName = '';
      this.vendorNameObjData = {
        value: "",
        text: ""
      };
      this.pageNo = 0;
      this.showModal = false;
      this.tripSheetData ={};
      this.ResponseData = [];
      this.VehicleTripBagDetails = [];
      this.showTable = false;
      this.$validator.reset();
      this.errors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/GenerateVehicleTripPrint/GenerateVehicleTripPrint.js